/**
 * Shared phone number formatting utilities.
 * Kept in one place so every component uses the same logic.
 */

/** Strip all non-digit characters */
const stripNonDigits = (value) => String(value || '').replace(/\D/g, '');

/** Format a raw phone string into display form: +1-702-555-1234 */
export const formatUSPhoneInput = (value) => {
  const digits = stripNonDigits(value);
  // Drop a leading country-code 1 so it doesn't bleed into the area code
  const core = digits.startsWith('1') ? digits.slice(1) : digits;
  const number = core.slice(0, 10);
  if (!number) return '';
  if (number.length <= 3) return `+1-${number}`;
  if (number.length <= 6) return `+1-${number.slice(0, 3)}-${number.slice(3)}`;
  return `+1-${number.slice(0, 3)}-${number.slice(3, 6)}-${number.slice(6, 10)}`;
};

/** Convert a raw phone string to E.164 format for Twilio */
export const toTwilioUSPhone = (value) => {
  const digits = stripNonDigits(value);
  if (!digits) return '';
  if (digits.length === 10) return `+1${digits}`;
  if (digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  if (String(value || '').trim().startsWith('+')) return `+${digits}`;
  return `+${digits}`;
};

/** Display a stored phone value in +1-xxx-xxx-xxxx format */
export const formatPhoneDisplay = (value) => {
  const digits = stripNonDigits(value);
  const core = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (core.length !== 10) return value || '-';
  return `+1-${core.slice(0, 3)}-${core.slice(3, 6)}-${core.slice(6)}`;
};

/** Quick check whether a string looks like phone input (digits, +, -, etc.) */
export const looksLikePhone = (s) => /^[\d+\-() ]*$/.test(s) && /\d/.test(s);
